function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#F9AB00",
  d: "M14 2.625v16.5C14 20.971 15.214 22 16.5 22c1.19 0 2.5-.875 2.5-2.875V2.75C19 1.058 17.81 0 16.5 0S14 1.166 14 2.625z"
}), React.createElement("path", {
  fill: "#E37400",
  d: "M7 11.505C7 10.113 8.19 9 9.5 9s2.5 1.009 2.5 2.624v7.633C12 21.165 10.69 22 9.5 22 8.214 22 7 21.018 7 19.257v-7.752zM2.5 22a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
}));

var SvgGoogleAnalytics = function SvgGoogleAnalytics(props) {
  return React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22"
  }, props), _ref);
};

export default SvgGoogleAnalytics;